import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=345e0a5c&scoped=true&"
import script from "./WaitingList.vue?vue&type=script&lang=js&"
export * from "./WaitingList.vue?vue&type=script&lang=js&"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=345e0a5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e0a5c",
  null
  
)

export default component.exports